import { useContext } from 'react';

import { MeetSanctionConfigurationStateContext } from './MeetSanctionConfigurationContextProvider';

import MeetSanctionConfigurationData from './MeetSanctionConfigurationData';

const useMeetSanctionConfigurationData = () => {
  const [meetSanctionConfigurationState, setMeetSanctionConfigurationState] = useContext(MeetSanctionConfigurationStateContext);

  const getMeetSanctionConfiguration = (meetClassificationId) => { 
    MeetSanctionConfigurationData.getMeetSanctionConfigurationData(meetClassificationId, meetSanctionConfigurationState, setMeetSanctionConfigurationState);
  }

  return {
    meetSanctionConfigurationState,
    getMeetSanctionConfiguration
  };
};

export default useMeetSanctionConfigurationData;